<template lang="pug">
    v-container(grid-list-md v-if="content" )
        v-layout(wrap)
            v-flex(lg8 md8 xs12)
                v-text-field(dense v-model="source" label="No. Rekening Sumber" readonly)
                    template(v-slot:prepend)
                        v-icon(color="warning") mdi-credit-card-multiple-outline
            v-flex(lg8 md8 xs12 v-if="content.note")
                v-text-field(dense v-model="content.note" label="Berita" readonly)
                    template(v-slot:prepend)
                        v-icon(color="primary") mdi-note-text-outline
            v-flex(lg8 md8 xs12 v-if="content.customerRef")
                v-text-field(dense v-model="content.customerRef" label="No. Dokumen" readonly)
                    template(v-slot:prepend)
                        v-icon(color="primary") mdi-file-document-outline
            v-flex(lg8 md8 xs12)
                v-text-field(dense v-model="destination" label="Tujuan Transaksi" readonly)
                    template(v-slot:prepend)
                        v-icon(color="success") mdi-account-check-outline
            v-flex(lg7 md7 xs12)
                f-decimalbox(v-model="content.summary.amount" label="Nominal" readonly :template="true")
            v-flex(lg7 md7 xs12)
                f-decimalbox(v-model="content.summary.fee" label="Biaya Admin" readonly :template="true")
            v-flex(lg7 md7 xs12)
                f-decimalbox(v-model="content.summary.totalAmount" label="Total" readonly :template="true")
                
</template>
<script>
export default {
  name: "FDefaultTransactionContent",
  props: ["content", "request", "transaction"],
  computed: {
    source() {
      return this.$options.filters.accountformat(this.content.source)+ " - " + this.content.sourceName;
    },
    destination() {
      return this.request.destinationNumber + " - " + this.request.destinationName;
    }
  }
};
</script>